import { render, staticRenderFns } from "./WBranch.vue?vue&type=template&id=5079c042&scoped=true&"
import script from "./WBranch.vue?vue&type=script&lang=js&"
export * from "./WBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079c042",
  null
  
)

export default component.exports